module.exports = __webpack_public_path__ + "static/media/partner-pscc.651ccf0f.png";